
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"29","height":"32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M21.267 14.688v-1.876h5.8V0h-1.934v10.938h-5.8V9.062H23.2V0h-1.933v7.188h-2.03a4.682 4.682 0 00-1.837-2.81V1.562h-1.933v1.97a4.983 4.983 0 00-1.934 0v-1.97H11.6v2.816a4.682 4.682 0 00-1.836 2.81h-2.03V0H5.8v9.063h3.867v1.874h-5.8V0H1.933v12.813h5.8v1.874H0V28.25h1.933V16.562h5.8v.938c0 .318.024.631.07.938H3.867V32H5.8V20.312h2.587c.956 1.946 2.87 3.366 5.146 3.683v1.942h1.934v-1.942c2.276-.317 4.19-1.737 5.146-3.683H23.2V32h1.933V18.437h-3.936c.046-.306.07-.619.07-.937v-.938h5.8V28.25H29V14.687h-7.733zM11.6 8.125c0-1.55 1.3-2.813 2.9-2.813 1.6 0 2.9 1.262 2.9 2.813v2.813h-5.8V8.124zm7.733 9.375c0 2.585-2.168 4.688-4.833 4.688S9.667 20.084 9.667 17.5v-4.688h9.666V17.5z","fill":"#fff"}})])
          )
        }
      }
    